import { Injectable } from '@angular/core';
import { Menu, SubMenu } from './menu-models';

export enum UserRoles {
  CORPORATE = 'cooperate', // super admin
  FULL_ACCESS = 'ccooperate', // staff
  TRANSPORTATION_COORDINATOR = 'cdispatcher' // staff
}

export enum Actions {
  TripEdit = 'tripEdit',
  StandingOrderEdit = 'standingOrderEdit'
}

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  menus = {};
  userRole;

  constructor() { }

  addMenu(menu: Menu): void {
    if (this.canView(menu.roles)) {
      this.menus[menu.key] = menu;
    }
  }

  getAssignedSubMenu(role){
   let subMenus = [
      {
        name: "All",
        value: "all",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "Staging",
        value: "intake",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "Unassigned",
        value: "unassigned",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "Assigned",
        value: "hanging",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "In Progress",
        value: "inprogress",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "Cancelled",
        value: "cancelled",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "Completed",
        value: "completed",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      }
    ];
    let roleSpecificMenus= [];

    for (let i = 0; i < subMenus.length; i++) {
      if (subMenus[i].roles.includes(role)) {
        roleSpecificMenus.push(subMenus[i]);
    }
    }
    return roleSpecificMenus;
  }

  getTripReportSubMenu(role) {
    let subMenus = [
      {
        name: "All",
        value: "all",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "Unassigned",
        value: "unassigned",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "Assigned",
        value: "hanging",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "In Progress",
        value: "inprogress",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "Cancelled",
        value: "cancelled",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      },
      {
        name: "Completed",
        value: "completed",
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      }
    ];
    let roleSpecificMenus = [];

    for (let i = 0; i < subMenus.length; i++) {
      if (subMenus[i].roles.includes(role)) {
        roleSpecificMenus.push(subMenus[i]);
      }
    }
    return roleSpecificMenus;
  }

  addSubMenu(key: string, subMenu: SubMenu) {
    if ((this.menus[key] && this.canView(subMenu.roles))) {
      const subMenus = this.menus[key].subMenus;
      if (!subMenus) {
        this.menus[key].subMenus = [];
      }
      this.menus[key].subMenus.push(subMenu);
    }
  }

  getMenu(userRole): object {
    this.menus = {};
    this.userRole = userRole;
    this.addMenus();
    return this.menus;
  }

  addMenus() {
    // Trips
    this.addMenu({
      title: "Trips",
      url: "trips",
      icon: this.getIcon("trips"),
      key: "trips",
      position: 1,
      roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR],
    });

    this.addSubMenu('trips', {
      title: "Trips",
      url: "trips",
      position: 1,
      roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR],
      actions: {
        [Actions.TripEdit]: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
      }
    });

    this.addSubMenu('trips', {
      title: "Trip Sheet",
      url: "trips/tripsheet",
      position: 2,
      roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    });

    this.addSubMenu('trips', {
      title: "New Trip",
      url: "trips/new",
      position: 3,
      roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    });

    //  // Standing Order
     this.addMenu({
      title: "STO",
      url: "standing-orders",
      icon: this.getIcon("manifest"),
      key: "standing-orders",
      position: 2.5,
      roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR],
      actions: {
        [Actions.StandingOrderEdit]: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
      }
    });

    // operations
    this.addMenu({
      title: "Ridecare",
      url: "operations",
      icon: this.getIcon("manifest"),
      key: "operations",
      position: 2,
      roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR],
    });

    this.addMenu({
      title: "Reports",
      url: "reports",
      icon: this.getIcon("reports"),
      key: "reports",
      position: 3,
      roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR],
    });

    this.addMenu({
      title: "OTP",
      url: "otp",
      icon: this.getIcon("reports"),
      key: "otp",
      position: 4,
      roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR],
    });

    // this.addSubMenu('standing-orders', {
    //   title: "Standing Orders",
    //   url: "standing-orders",
    //   position: 1,
    //   roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    // });

    // // Credentails
    this.addMenu({
      title: "Profiling",
      url: "credentialing",
      icon: this.getIcon("credentialing"),
      key: "credentialing",
      position: 5,
      roles: [UserRoles.CORPORATE],
    });

    // this.addSubMenu('credentialing', {
    //   title: "Members",
    //   url: "credentialing/members",
    //   position: 4,
    //   roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    // });

    this.addSubMenu('credentialing', {
      title: "Staff",
      url: "credentialing/staff",
      position: 1,
      roles: [UserRoles.CORPORATE]
    });
   
  }

  getMenuForFacility(userRole, user?) {
    this.menus = {};
    this.userRole = userRole;
    this.addMenus();

    const allowPlacement = user ? user.allowPlacement : false;

    if (allowPlacement) {
      this.addMenu({
        title: "Placement",
        url: "placement",
        icon: this.getIcon("placement"),
        key: "placement",
        position: 6,
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR],
      });

      this.addSubMenu('placement', {
        title: "Patient",
        url: "placement/patient",
        position: 1,
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      });

      this.addSubMenu('placement', {
        title: "Reservations",
        url: "placement/reservations",
        position: 2,
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      });

      this.addSubMenu('placement', {
        title: "Assist",
        url: "placement/assists",
        position: 3,
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      });

      this.addSubMenu('placement', {
        title: "Messages",
        url: "placement/messages",
        position: 4,
        roles: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
      });
    }
    return this.menus;
  }

  getIcon(menu) {
    switch (menu) {
     
      case 'trips':
        return `<svg
        class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M14.844 20H6.5C5.121 20 4 18.879 4 17.5S5.121 15 6.5 15h7c1.93 0 3.5-1.57 3.5-3.5S15.43 8 13.5 8H8.639a9.812 9.812 0 0 1-1.354 2H13.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-7C4.019 13 2 15.019 2 17.5S4.019 22 6.5 22h9.593a10.415 10.415 0 0 1-1.249-2zM5 2C3.346 2 2 3.346 2 5c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5 6.5z"
        />
        <path
          fill="currentColor"
          d="M19 14c-1.654 0-3 1.346-3 3c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 19 18.5z"
        />
      </svg>`;
      case "manifest":
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
      </svg>
      `;
      case 'credentialing':
        return `<svg class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32">
        <path fill="currentColor" d="M16 22a4 4 0 1 0-4-4a4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2a2 2 0 0 1 2-2zM14 6h4v2h-4z" />
        <path fill="currentColor"
          d="M24 2H8a2.002 2.002 0 0 0-2 2v24a2.002 2.002 0 0 0 2 2h16a2.003 2.003 0 0 0 2-2V4a2.002 2.002 0 0 0-2-2Zm-4 26h-8v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Zm2 0v-2a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v2H8V4h16v24Z" />
      </svg>`;
      case 'reports':
        return `<svg
        class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
        />
      </svg>`

      case 'placement':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205 3 1m1.5.5-1.5-.5M6.75 7.364V3h-3v18m3-13.636 10.5-3.819" />
</svg>
`
     

      default:
        return '<svg class="navbar-svg-default mr-4 flex-shrink-0 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" /></svg>';
    }
  }

  canView(menuRoles) {
    if (Array.isArray(this.userRole)) {
      // In case if user has multiple roles assigned to them.
      // Logic will be added here if needed.
      return false;
    }

    return menuRoles.includes(this.userRole);
  }

  getUserRoleTitle(role) {
    let title = '';
     if (role === UserRoles.CORPORATE) {
      title = "Admin";
    } else if (role === UserRoles.FULL_ACCESS) {
      title = 'Full Access'
    } else if (role === UserRoles.TRANSPORTATION_COORDINATOR) {
      title = 'Transportation Coordinator'
    } else {
      title = role;
    }

    return title;
  }
}
